import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { useTranslation } from "react-i18next"
import Form from "../../components/Form"
import SurveyLoginStates from "./Features/SurveyLoginStates"
import useSurveyLogin from "./useSurveyLogin"
import styles from "../Login/login.module.scss"

/**
 * Site-survey login. Shares only the stylesheet and the generic `Form` with the
 * commissioning login — the fields, validation, submit and redirect are its own.
 */
const SurveyLogin = () => {
    const { t: translate } = useTranslation()
    const { states } = useSurveyLogin()

    const formData = {
        fields: [
            {
                type: "text",
                name: "name",
                label: translate("surveyorName"),
                placeholder: "Enter",
                required: true,
                labelFontWeight: 500,
            },
            {
                type: "tel",
                name: "phone",
                label: translate("surveyorNumber"),
                placeholder: "Enter",
                required: true,
                labelFontWeight: 500,
                digitsOnly: true,
                inputProps: { inputMode: "numeric", maxLength: 10, pattern: "[0-9]*" },
            },
            {
                type: "text",
                name: "vendor_code",
                label: translate("uniqueCode"),
                // Same dashed hint the commissioning login uses, but six wide:
                // survey codes are 6 digits, and the legacy ones are "S" plus
                // 5 hex characters (§2.1) — six either way.
                placeholder: "------",
                required: true,
                labelFontWeight: 500,
                text: translate("surveyCodeHelp"),
                inputProps: { maxLength: 6, autoCapitalize: "characters" },
            },
        ],
    }

    if (states.loader) {
        return (
            <Box className={styles.login_wrapper}>
                <SurveyLoginStates loading={states.loader} error={Boolean(states.loginError)} />
            </Box>
        )
    }

    return (
        <Box className={styles.login_wrapper}>
            <Box className={styles.form_wrapper}>
                <Typography className={styles.form_wrapper__heading}>
                    {translate("greetings")}
                </Typography>
                <Typography className={styles.form_wrapper__sub_heading}>
                    {translate("welcome")}
                </Typography>
                {/* noValidate: every field is `required`, so the browser's own
                    bubbles would fire before Formik and suppress the styled errors. */}
                <form noValidate onSubmit={states.formik.handleSubmit}>
                    <Form {...{ data: formData, formik: states.formik }} />
                    <Box className={styles.form_wrapper__button_container}>
                        <Button
                            loading={states.isLoginLoading}
                            size="small"
                            variant="outlined"
                            type="submit"
                        >
                            {translate("verify")}
                        </Button>
                    </Box>
                </form>
            </Box>
        </Box>
    )
}

export default SurveyLogin
